import slugify from "slugify";
import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import "moment/locale/es";

export const updateSectionOrder = (sections) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: "START_SECTION_REORDER" });

    const promises = sections.map((section, index) => {
      return firestore
        .collection("categories")
        .doc(section.id)
        .set({ order: index }, { merge: true });
    });

    return Promise.all(promises)
      .then(() => {
        dispatch({ type: "SECTION_REORDER_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "SECTION_REORDER_ERROR", error });
      });
  };
};

export const updateProductOrder = (products, sectionId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: "START_PRODUCT_REORDER" });

    const promises = products.map((product, index) => {
      return firestore
        .collection("categories")
        .doc(sectionId)
        .collection("products")
        .doc(product.id)
        .set({ order: index }, { merge: true });
    });

    return Promise.all(promises)
      .then(() => {
        dispatch({ type: "PRODUCT_REORDER_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "PRODUCT_REORDER_ERROR", error });
      });
  };
};

export const updateSaleBanners = (files, deletedFiles) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const deletedFilesPromises = deletedFiles.map((deletedFile) => {
      return firestore
        .collection("carousel")
        .where("image", "==", deletedFile)
        .get()
        .then((snapshot) => {
          const carouselPromises = [];
          snapshot.docs.forEach((doc) => {
            if (doc.exists) carouselPromises.push(doc.ref.delete());
          });

          return Promise.all(carouselPromises);
        })
        .then(() => deleteFileFromStorage(firebase, deletedFile));
    });

    const filePromises = files.map((file) => {
      if (typeof file === "string") return file;

      return uploadFileToStorage(firebase, file, "carousel").then((url) => {
        return firestore.collection("carousel").add({ image: url });
      });
    });
    return Promise.all(filePromises)
      .then((result) => {
        return Promise.all(deletedFilesPromises);
      })
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const updateSection = (section) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "START_SECTION_UPDATE" });

    return uploadCategory(section, firebase, firestore)
      .then(() => {
        dispatch({ type: "SECTION_UPDATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "SECTION_UPDATE_ERROR", error });
      });
  };
};

export const resetUpdateSection = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_SECTION_UPDATE" });
  };
};

export const newSection = (section) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "START_SECTION_CREATE" });

    return uploadCategory(section, firebase, firestore)
      .then(() => {
        dispatch({ type: "SECTION_CREATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "SECTION_CREATE_ERROR", error });
      });
  };
};

export const resetCreateSection = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_SECTION_CREATE" });
  };
};

export const deleteSection = (sectionId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: "START_SECTION_DELETE" });

    return firestore
      .collection("categories")
      .doc(sectionId)
      .delete()
      .then(() => {
        dispatch({ type: "SECTION_DELETE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "SECTION_DELETE_ERROR", error });
      });
  };
};

export const resetDeleteSection = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_SECTION_DELETE" });
  };
};

export const updateProduct = (product, sectionId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "START_PRODUCT_UPDATE" });

    return uploadProduct(product, firebase, firestore, sectionId)
      .then(() => {
        dispatch({ type: "PRODUCT_UPDATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "PRODUCT_UPDATE_ERROR", error });
      });
  };
};

export const resetUpdate = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_PRODUCT_UPDATE" });
  };
};

export const newProduct = (product, restaurantId, sectionId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "START_PRODUCT_CREATE" });

    return uploadProduct(product, firebase, firestore, restaurantId, sectionId)
      .then(() => {
        dispatch({ type: "PRODUCT_CREATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "PRODUCT_CREATE_ERROR", error });
      });
  };
};

export const resetCreate = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_PRODUCT_CREATE" });
  };
};

export const deleteProduct = (productId, sectionId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: "START_PRODUCT_DELETE" });

    return firestore
      .collection("categories")
      .doc(sectionId)
      .collection("products")
      .doc(productId)
      .delete()
      .then(() => {
        dispatch({ type: "PRODUCT_DELETE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "PRODUCT_DELETE_ERROR", error });
      });
  };
};

export const resetDelete = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_PRODUCT_DELETE" });
  };
};

export const uploadProduct = (product, firebase, firestore, sectionId) => {
  const {
    image,
    imageUrl,
    price,
    description,
    title,
    Toppings,
    available,
    id,
  } = product;

  if (id && !id.includes("-")) {
    if (image.length > 0) {
      return uploadFileToStorage(
        firebase,
        image[0],
        `menu/${sectionId}/products`
      ).then((url) => {
        return firestore
          .collection("categories")
          .doc(sectionId)
          .collection("products")
          .doc(id)
          .set(
            { price, description, title, image: url, Toppings, available },
            { merge: true }
          );
      });
    }

    return firestore
      .collection("categories")
      .doc(sectionId)
      .collection("products")
      .doc(id)
      .set(
        { price, description, title, image: imageUrl, Toppings, available },
        { merge: true }
      );
  }

  return uploadFileToStorage(
    firebase,
    image[0],
    `menu/${sectionId}/products`
  ).then((url) => {
    return firestore
      .collection("categories")
      .doc(sectionId)
      .collection("products")
      .get()
      .then((snapshot) => {
        return snapshot.docs.length;
      })
      .then((count) => {
        return firestore
          .collection("categories")
          .doc(sectionId)
          .collection("products")
          .add({
            price,
            description,
            title,
            image: url,
            Toppings,
            order: count,
            available,
          });
      });
  });
};

export const uploadCategory = (section, firebase, firestore) => {
  const { title, image, products, id, imageUrl, available } = section;
  let sectionId;

  if (id && !id.includes("-")) {
    if (image.length > 0) {
      return uploadFileToStorage(firebase, image[0], `menu/${sectionId}`).then(
        (url) => {
          return firestore.collection("categories").doc(id).set(
            {
              image: url,
              title,
              available,
            },
            { merge: true }
          );
        }
      );
    }

    return firestore.collection("categories").doc(id).set(
      {
        image: imageUrl,
        title,
        available,
      },
      { merge: true }
    );
  }

  return firestore
    .collection("categories")
    .get()
    .then((snapshot) => {
      return snapshot.docs.length;
    })
    .then((count) => {
      return firestore
        .collection("categories")
        .add({ title, order: count, available })
        .then((doc) => {
          sectionId = doc.id;

          return uploadFileToStorage(
            firebase,
            image[0],
            `menu/${sectionId}`
          ).then((url) => {
            return firestore.collection("categories").doc(sectionId).set(
              {
                image: url,
              },
              { merge: true }
            );
          });
        });
    });
};

export const updateDrivers = (restaurantId, drivers, deletedDrivers) => {
  return (dispatch, getState, { getFirebase }) => {
    dispatch({ type: "START_DRIVER_UPDATE" });

    const firebase = getFirebase();

    const callableReturnMessage = firebase
      .functions()
      .httpsCallable("updateDrivers");

    return callableReturnMessage({ restaurantId, drivers, deletedDrivers })
      .then(() => {
        dispatch({ type: "DRIVER_UPDATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "DRIVER_UPDATE_ERROR", error });
      });
  };
};

export const setOrderDriver = (restaurantId, driverId, orderId, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    return firestore
      .collection("restaurants")
      .doc(restaurantId)
      .collection("orders")
      .doc(orderId)
      .set({ driverID: driverId }, { merge: true })
      .then(() => {
        return firestore
          .collection("orders")
          .doc(orderId)
          .set({ driverID: driverId }, { merge: true });
      })
      .then(() => {
        return firestore
          .collection("users")
          .doc(userId)
          .collection("orders")
          .doc(orderId)
          .set({ driverID: driverId }, { merge: true });
      });
  };
};

export const setOrderStatus = (restaurantId, status, orderId, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    return firestore
      .collection("restaurants")
      .doc(restaurantId)
      .collection("orders")
      .doc(orderId)
      .set({ status }, { merge: true })
      .then(() => {
        return firestore
          .collection("orders")
          .doc(orderId)
          .set({ status }, { merge: true });
      })
      .then(() => {
        return firestore
          .collection("users")
          .doc(userId)
          .collection("orders")
          .doc(orderId)
          .set({ status }, { merge: true });
      });
  };
};

export const editRestaurant = (restaurantId, restaurant) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: "START_RESTAURANT_UPDATE" });

    return firestore
      .collection("restaurants")
      .doc(restaurantId)
      .set({ ...restaurant }, { merge: true })
      .then(() => {
        dispatch({ type: "RESTAURANT_UPDATE_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "RESTAURANT_UPDATE_ERROR", error });
      });
  };
};

export const generateReport = (restaurantId, startDate, endDate) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "START_REPORT_GEN" });

    const orders = [];
    let header = false;
    const headers = [
      "Estado",
      "Nombre del cliente",
      "Número telefónico",
      "Fecha de creación",
      "Dirección",
      "Distancia",
      "Método de pago",
      "Productos",
      "Costo de envío",
      "Costo",
    ];
    const dataKeys = [
      "status",
      "client",
      "phoneNumber",
      "dateCreated",
      "address",
      "distanceToTravel",
      "paymentMethod",
      "products",
      "deliveryCost",
      "cost",
    ];

    return firestore
      .collection("restaurants")
      .doc(restaurantId)
      .collection("orders")
      .where("dateCreated", ">", startDate)
      .where("dateCreated", "<", endDate)
      .orderBy("dateCreated", "desc")
      .get()
      .then((snapshot) => {
        orders.push(headers);

        snapshot.forEach((s) => {
          const order = s.data();

          const data = dataKeys.map((key) => {
            if (key === "status") return order[key].toUpperCase();
            if (key === "dateCreated")
              return moment(order[key].toDate()).format(
                "MMMM Do YYYY, h:mm:ss a"
              );
            if (key === "products")
              return order[key]
                .map(({ product, toppings }, index) => {
                  let s = "";

                  Object.keys(toppings).forEach((key, i) => {
                    const options = toppings[key];
                    if (i > 0) s += "; ";
                    s += key + ": ";

                    options.forEach((option, index) => {
                      const total =
                        typeof option.cost === "string"
                          ? parseFloat(option.cost)
                          : option.cost;
                      if (index > 0) s += ", ";
                      s += `${option.name} ($${total})`;
                    });
                  });

                  return `${index > 0 ? " " : ""}${product.title} (${s})`;
                })
                .toString();
            return order[key];
          });

          orders.push(data);
        });

        return orders;
      })
      .then(() => {
        dispatch({ type: "REPORT_GEN_SUCCESS", orders });
      })
      .catch((error) => {
        dispatch({ type: "REPORT_GEN_ERROR", error });
      });
  };
};

function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
}

function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = this.convertToCSV(jsonObject);

  var exportedFilenmae = fileTitle + ".csv" || "export.csv";

  var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

const uploadFileToStorage = (firebase, file, path) => {
  return firebase
    .storage()
    .ref()
    .child(`${path}/${slugify(file.name, "_")}-${uuidv4()}`)
    .put(file)
    .then((res) => {
      return res.ref.getDownloadURL();
    });
};

const deleteFileFromStorage = (firebase, path) => {
  return firebase.storage().refFromURL(path).delete();
};
